import styled, { AnyStyledComponent } from 'styled-components';
import type { SvgIconProps } from './SvgIcon';

/**
 * Gets the correct color for the inner svg elements.
 * NOTE: 'currentColor' will inherit color from the surrounding text
 */
export const getColor = (
  color: SvgIconProps['color'],
  isColorInherited: SvgIconProps['isColorInherited'],
) => (isColorInherited ? 'currentColor' : color);

export const createTileCategory = (IconCategory: AnyStyledComponent) => styled(IconCategory)`
  position: absolute;
  top: -2px;
  right: -3px;
`;
